<template>
    <div class="collection-points-app">
        <router-view/>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        props: {
            cantonDetailSearchValue: {
                type: String,
                required: true,
            },
            loadMapEntries: {
                type: String,
                required: true,
            },
            loadEntryDetails: {
                type: String,
                required: true,
            },
            loadSearchResults: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapState('collection-points', ['api']),
        },
        methods: {
            ...mapActions('collection-points', ['setApiEndpoints', 'setCantonDetailSearchValue', 'loadEntries']),
        },
        created() {
            const { cantonDetailSearchValue, loadMapEntries, loadEntryDetails, loadSearchResults } = this;

            this.setCantonDetailSearchValue({ value: cantonDetailSearchValue });
            this.setApiEndpoints({
                api: { loadMapEntries, loadEntryDetails, loadSearchResults },
            });
        },
        mounted() {
            this.loadEntries({ url: this.api.loadMapEntries });
        },
    };
</script>
